import { render, staticRenderFns } from "./Novel.vue?vue&type=template&id=ab7e0c4a&scoped=true&"
import script from "./Novel.vue?vue&type=script&lang=js&"
export * from "./Novel.vue?vue&type=script&lang=js&"
import style0 from "./Novel.vue?vue&type=style&index=0&id=ab7e0c4a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab7e0c4a",
  null
  
)

export default component.exports